export default "__VITE_PUBLIC_ASSET__210f1640__"